import BaseController from "./BaseController";
import Event from "sap/ui/base/Event";

/**
 * ADR-018 §5 — Landing page dla license-only userów którzy trafili do portal-spa.
 *
 * Cel: zamiast pokazywać 403/AuthError lub pusty portal shell użytkownikom z
 * `HasPortalAccess=false` (Luna AI / WebUp end-users), routujemy ich do friendly
 * landing page z linkami do produktów CompuTec. Detection robi App.controller
 * (T6 niniejszego taska) na podstawie `/api/v1/me.hasPortalAccess`.
 *
 * Flow:
 *   1. Component bootstrap → enrichUserModelAsync → user model ma `/hasPortalAccess`.
 *   2. App.controller.onInit → jeśli `hasPortalAccess === false`, navTo `noPortalAccess`
 *      PRZED Pending detection (license-only userzy nie powinni przejść przez
 *      _maybeAutoAcceptInvitation, bo są już Active w innej dimensji).
 *   3. View pokazuje produkty CompuTec; klik otwiera URL w nowej karcie (rel=noopener).
 *
 * @namespace computec.b2b.portal.controller
 */
export default class NoPortalAccess extends BaseController {
	/**
	 * Handler dla product button — otwiera URL z customData:productUrl w nowej karcie.
	 * `noopener,noreferrer` blokuje window.opener tampering (security best practice dla
	 * cross-origin linków).
	 */
	public onOpenProduct(event: Event): void {
		// Inline cast przez `unknown` (UI5 EventProvider type jest loose; `data(key)` to
		// metoda Element). Walidujemy zwróconą wartość jako string przed window.open.
		const source = event.getSource() as unknown as { data(key: string): unknown };
		const url = source.data("productUrl");
		if (typeof url === "string" && url.length > 0) {
			window.open(url, "_blank", "noopener,noreferrer");
		}
	}
}
